/**
 * A logger is injected into the Remix loader and action contexts by the server.
 *
 * Use this module if you want to create a logger directly. Loggers are cheap to
 * create and they work in both the frontend and backend.
 */

import { createLogger } from "@repo/utils";

export const logger = createLogger();
